export default "__VITE_ASSET__Ccier9S7__"